import { Link, useLocation, useParams } from 'react-router-dom';
import './FooterTagSection.css';





export default function FooterTagSection({ clubInfo, relatedLinks  }) {

    const [clubname, city, area] = clubInfo?.split("-").map((str) => str.replace(/_/g, " "));



    return (
        <>
            <div className='vcdp-FooterTagSection'>
                <div className='vcdp-FooterTagSection-container'>
                    <div className='vcdp-FooterTagSection-content-header'>
                        <h1>Related to {clubname} - {area} - {city} </h1>
                    </div>
                    <div className='vcdp-FooterTagSection-content'>
                        <p className="vcdp-FooterTagSection-content-text-tags">
                            {relatedLinks.map((item, index) => (
                                <span key={index}>
                                    <Link
                                        to={item.url}
                                        className={item?.url ? 'vcdp-tag-link-blue' : 'vcdp-tag-link'}
                                    >
                                        {item.tag}
                                    </Link>
                                    {index !== relatedLinks.length - 1 && ", "}
                                </span>
                            ))}
                        </p>
                    </div>
                </div>
            </div>

        </>
    )
}
